module.exports = __webpack_public_path__ + "img/us.cbfe8d83.svg";